/* Detailing1 — generisches Tooltip-Modul (.d1-tip), global geladen.
   Reagiert auf jedes Element mit data-d1-tip-title (+ optional -sub, -icon).
   Erscheint bei Hover und Tastatur-Fokus; robustes Positionieren via fixed +
   getBoundingClientRect (kein Clipping durch overflow). Unterdrückt den
   nativen title NUR an Elementen, die einen d1-tip bekommen.
   Init-Guard; rührt den Such-Sparkle-Tooltip nicht an (anderer Selektor).
   Rausnehmen = revert (Block aus theme.liquid + Assets). */
(function () {
  if (window.__d1Tip) return;
  window.__d1Tip = true;

  var ICONS = {
    chat: '<svg viewBox="0 0 16 16" aria-hidden="true"><path fill="currentColor" d="M2.5 2h11A1.5 1.5 0 0 1 15 3.5v7a1.5 1.5 0 0 1-1.5 1.5H7.6l-3.3 2.7A.6.6 0 0 1 3.3 14v-2H2.5A1.5 1.5 0 0 1 1 10.5v-7A1.5 1.5 0 0 1 2.5 2z"/></svg>',
    sparkle: '<svg viewBox="0 0 16 16" aria-hidden="true">' +
      '<path fill="currentColor" d="M6.13 1.87 Q6.81 5.99 10.93 6.67 Q6.81 7.34 6.13 11.47 Q5.46 7.34 1.33 6.67 Q5.46 5.99 6.13 1.87Z"/>' +
      '<path fill="currentColor" d="M12.47 1.93 Q12.72 3.48 14.27 3.73 Q12.72 3.99 12.47 5.53 Q12.21 3.99 10.67 3.73 Q12.21 3.48 12.47 1.93Z"/>' +
      '<path fill="currentColor" d="M11.73 9.0 Q12.08 11.12 14.2 11.47 Q12.08 11.81 11.73 13.93 Q11.39 11.81 9.27 11.47 Q11.39 11.12 11.73 9.0Z"/></svg>',
    info: '<svg viewBox="0 0 16 16" aria-hidden="true"><path fill="currentColor" d="M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1zm0 2.6a1 1 0 1 1 0 2 1 1 0 0 1 0-2zM6.9 7h1.6a.5.5 0 0 1 .5.5V11h.7a.5.5 0 0 1 0 1H6.4a.5.5 0 0 1 0-1h.6V8h-.1a.5.5 0 0 1 0-1z"/></svg>'
  };

  var tip, iconEl, titleEl, subEl, arrowEl, current = null, hideTimer = null;

  function build() {
    tip = document.createElement('div');
    tip.className = 'd1-tip';
    tip.setAttribute('role', 'tooltip');
    tip.innerHTML =
      '<div class="d1-tip__row"><span class="d1-tip__icon"></span>' +
      '<span><span class="d1-tip__title"></span><span class="d1-tip__sub"></span></span></div>' +
      '<span class="d1-tip__arrow"></span>';
    document.body.appendChild(tip);
    iconEl = tip.querySelector('.d1-tip__icon');
    titleEl = tip.querySelector('.d1-tip__title');
    subEl = tip.querySelector('.d1-tip__sub');
    arrowEl = tip.querySelector('.d1-tip__arrow');
  }

  function fill(el) {
    titleEl.textContent = el.getAttribute('data-d1-tip-title') || '';
    subEl.textContent = el.getAttribute('data-d1-tip-sub') || '';
    iconEl.innerHTML = ICONS[el.getAttribute('data-d1-tip-icon')] || '';
    iconEl.style.color = el.getAttribute('data-d1-tip-color') || '';  // leer -> CSS-Default (#0095f0)
  }

  function place(el) {
    var r = el.getBoundingClientRect();
    var tr = tip.getBoundingClientRect();
    var gap = 10, margin = 8;
    var top = r.top - tr.height - gap, below = false;
    if (top < 6) { top = r.bottom + gap; below = true; }
    var center = r.left + r.width / 2;
    var left = Math.max(margin, Math.min(center - tr.width / 2, window.innerWidth - tr.width - margin));
    tip.style.top = Math.round(top) + 'px';
    tip.style.left = Math.round(left) + 'px';
    var ax = Math.max(12, Math.min(center - left - 5, tr.width - 22));
    arrowEl.style.left = Math.round(ax) + 'px';
    if (below) {
      arrowEl.style.top = '-5px'; arrowEl.style.bottom = 'auto'; arrowEl.style.transform = 'rotate(225deg)';
    } else {
      arrowEl.style.top = 'auto'; arrowEl.style.bottom = '-5px'; arrowEl.style.transform = 'rotate(45deg)';
    }
  }

  function show(el) {
    if (!tip) build();
    if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; }
    current = el;
    if (el.getAttribute('title')) el.removeAttribute('title');
    fill(el);
    tip.style.visibility = 'hidden';
    tip.classList.add('is-visible');
    requestAnimationFrame(function () {
      if (current !== el) return;
      place(el);
      tip.style.visibility = 'visible';
    });
  }

  function hide() { if (tip) { current = null; tip.classList.remove('is-visible'); } }
  function hideSoon() { hideTimer = setTimeout(hide, 90); }

  function target(el) { return el && el.closest ? el.closest('[data-d1-tip-title]') : null; }

  function stripTitles() {
    var list = document.querySelectorAll('[data-d1-tip-title][title]');
    for (var i = 0; i < list.length; i++) list[i].removeAttribute('title');
  }

  document.addEventListener('mouseover', function (e) { var t = target(e.target); if (t) show(t); });
  document.addEventListener('mouseout', function (e) { if (target(e.target)) hideSoon(); });
  document.addEventListener('focusin', function (e) { var t = target(e.target); if (t) show(t); });
  document.addEventListener('focusout', function (e) { if (target(e.target)) hideSoon(); });
  document.addEventListener('click', function (e) { if (target(e.target)) hide(); });
  window.addEventListener('scroll', function () { if (current) hide(); }, { capture: true, passive: true });
  window.addEventListener('resize', function () { if (current) place(current); });

  if (document.readyState !== 'loading') stripTitles();
  else document.addEventListener('DOMContentLoaded', stripTitles);
})();
